// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__2ciN-","selects":"Documents_selects__3wD-m"};